import "./index.scss";
import { HeroImageProps } from "./types";
import React from "react";

const HeroImage = ({ image }: HeroImageProps) => {
  const style = image
    ? {
        backgroundImage: `url(${image})`,
      }
    : {};
  return <div className="HeroImage box-shadow-card" style={style} />;
};

export default HeroImage;
